

import JSPM               from 'jsprintmanager'

JSPM.JSPrintManager.auto_reconnect = true;
JSPM.JSPrintManager.start();

export default {
    methods: { 

    printTicketCortesia_jspm(receiptText,sale)
    {
 
        
        const jspmWSStatus = () => {
            if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open)
                return true;
            else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Closed) {
                alert('JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm');
                return false;
            }
            else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Blocked) {
                alert('JSPM has blocked this website!');
                return false;
            }
        }

 

   
    const GS       = '\x1d'  
    const esc      = '\x1B'; //ESC byte in hex notation
    const newLine  = '\x0A'; //LF byte in hex notation

    var cmds       = esc + "@"; //Initializes the printer (ESC @)
   
    cmds += newLine + newLine + newLine  

     

    // HEADER 
    receiptText.forEach(row =>{
      if(row.type == 'H')
      {
        if(row.order_by == 1)
        {   
               
            cmds += esc + 'a' + '\x01'
            cmds += esc + '!' + '\x38'; //Emphasized + Double-height + Double-width mode selected (ESC ! (8 + 16 + 32)) 56 dec => 38 hex
            cmds += row.text  //text to print
            cmds += newLine;
            
        }
        else
        {
            cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)
            cmds += row.text  //text to print
            cmds += newLine;
        }
        
      }

    })
    
    
    cmds += newLine;

    cmds += esc + 'a' + '\x01'
    cmds += GS + '!' +  '\x01'
    cmds += 'SCONTRINO DI CORTESIA'    //text to print

  
    
    const data = sale.create_at + ' ' + sale.hour_at
    
    cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)
    
    cmds += newLine
    cmds += newLine
    cmds += newLine
    cmds += data    //text to print
    cmds += newLine

    cmds += newLine


    // BARCODE  
    cmds += esc + 'a' + '\x01'
    cmds += GS  + 'h' + '\x50'
    cmds += GS  + 'H' + '\x02'
    cmds += GS  + 'f' + '\x01'
    
    cmds += GS  + 'k' + '\x04' + 'S' +  sale.saleId + '\x00'
    
    
    cmds += newLine
    cmds += newLine
    cmds += newLine


    // FOOTER
    receiptText.forEach(row=>{

      if(row.type=='F')
      {

        if(row.order_by > 0)
        {
          cmds += row.text   //text to print
          cmds += newLine
        }

      }
    })

    cmds += newLine
    cmds += newLine
    cmds += newLine
    cmds += newLine
    cmds += newLine

    cmds += GS + 'V' + '\x01'   
    cmds += newLine
     
    
     if (jspmWSStatus()) {
            //Create a ClientPrintJob
            var cpj = new JSPM.ClientPrintJob();
            cpj.clientPrinter = new JSPM.DefaultPrinter();
            
            /*
            //Set Printer type (Refer to the help, there many of them!)
            if ($('#useDefaultPrinter').prop('checked')) {
                cpj.clientPrinter = new JSPM.DefaultPrinter();
            } else {
                cpj.clientPrinter = new JSPM.InstalledPrinter($('#installedPrinterName').val());
            }
            */

            cpj.printerCommands = cmds;
            //Send print job to printer!
            cpj.sendToClient();
            

     }

    
  }
}
}
  